import { STOREFRONT_ART } from "../../config/storefront-assets";
import { rarityClass } from "../../lib/motion";

/**
 * The Mr Gaole card backing. Every card in a pack, a raffle prize queue or the
 * vault shows this face before it is revealed.
 */
export function CardBack({
  className = "",
  tierName,
  imageUrl,
  shimmer = true,
  label,
}: {
  className?: string;
  /** When known, tints the halo with the rarity the card will turn out to be. */
  tierName?: string | null;
  /** Category backing image; falls back to the default Mr Gaole card back. */
  imageUrl?: string | null;
  shimmer?: boolean;
  /** Small caption printed under the emblem, e.g. "3 / 5". */
  label?: string;
}) {
  const src = imageUrl?.trim() || STOREFRONT_ART.cardBack;

  return (
    <div
      className={`relative isolate overflow-hidden rounded-2xl bg-brand-dark ${tierName ? rarityClass(tierName) : ""} ${className}`}
    >
      <img
        src={src}
        alt=""
        aria-hidden
        className="h-full w-full select-none object-cover"
        draggable={false}
      />
      {shimmer && (
        <span
          aria-hidden
          className="pointer-events-none absolute inset-0 z-10"
          style={{
            background:
              "linear-gradient(115deg, transparent 42%, rgba(255,255,255,0.22) 50%, transparent 58%)",
            backgroundSize: "260% 100%",
            animation: "holo-drift 4.5s linear infinite",
          }}
        />
      )}
      {label && (
        <>
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-10 bg-gradient-to-t from-black/90 to-transparent"
          />
          <span className="absolute inset-x-0 bottom-2 z-20 text-center font-display text-[9px] font-bold uppercase tracking-[0.25em] text-white/85 drop-shadow-[0_1px_3px_rgba(0,0,0,0.9)]">
            {label}
          </span>
        </>
      )}
    </div>
  );
}
